const defaultResources = {
  administradores: 0,
  alumnos: 0,
  instructores: 0,
  mapas: 0,
  maximo_administradores: 10000,
  maximo_alumnos: 20000,
  maximo_emails: 1000,
  maximo_instructores: 10000,
  maximo_mapas: 1000,
  maximo_productos: 1000,
  maximo_profesores: 10000,
  maximo_proyectos: 1000,
  maximo_puntos_venta: 1000,
  productos: 0,
  profesores: 0,
  proyectos: 0
}

export default defaultResources
